import React, { useEffect, useState } from "react";
import { Alert, Box, MenuItem, TextField } from "@mui/material";
import { useAuth } from "context/AuthContext";
import api from "services/api";
import { isAdminUser } from "modules/systems/services/application.service";
import ContractStatisticsPanel from "../components/statistics/ContractStatisticsPanel";
import { safely, subcontractApi } from "../services/subcontractApi";
import { AppAutocomplete } from "components/common/inputs";

const getField = (item, field) => item?.[field] ?? item?.[`${field.charAt(0).toUpperCase()}${field.slice(1)}`];

export default function StatisticsPage() {
  const { user } = useAuth();
  const [contracts, setContracts] = useState([]);
  const [selectedContractId, setSelectedContractId] = useState("");
  const [error, setError] = useState("");
  const [allowedSubcontractIds, setAllowedSubcontractIds] = useState(null);

  useEffect(() => {
    safely(() => subcontractApi.getContracts({ pageSize: 1000, pageNumber: 1 }))
      .then((result) => {
        const items = result.data || [];
        setContracts(items);
        setSelectedContractId((current) => current || getField(items[0], "contractId") || "");
        setError("");
      })
      .catch((requestError) => {
        setContracts([]);
        setSelectedContractId("");
        setError(requestError.response?.data?.message || requestError.message || "Không thể tải danh sách hợp đồng chính.");
      });
  }, []);

  useEffect(() => {
    let active = true;

    const loadAccessibleSubcontracts = async () => {
      if (!user?.userId) {
        if (active) setAllowedSubcontractIds("none");
        return;
      }

      if (isAdminUser(user)) {
        if (active) setAllowedSubcontractIds("all");
        return;
      }

      try {
        const response = await api.get(`/UserSubcontract/user/${user.userId}`, {
          params: { pageSize: 1000, pageNumber: 1 },
        });
        const entries = response?.data?.data || [];
        const ids = entries
          .map((item) => item.subcontractId ?? item.SubcontractId)
          .filter((value) => value != null);

        if (active) setAllowedSubcontractIds(ids.length > 0 ? ids : "none");
      } catch (requestError) {
        if (active) {
          setAllowedSubcontractIds("error");
          setError(
            requestError.response?.data?.message ||
            requestError.message ||
            "KhÃ´ng thá»ƒ táº£i danh sÃ¡ch phÃ¢n quyá»n giao khoÃ¡n.",
          );
        }
      }
    };

    setAllowedSubcontractIds(null);
    loadAccessibleSubcontracts();

    return () => {
      active = false;
    };
  }, [user]);

  return (
    <Box className="subcontract-page">
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Box className="subcontract-stat-filter">
        {/* <TextField
          select
          size="small"
          label="Hợp đồng chính"
          value={selectedContractId}
          onChange={(event) => setSelectedContractId(event.target.value)}
          sx={{ minWidth: { xs: 0, sm: 420 }, width: { xs: "100%", sm: "auto" } }}
        >
          {contracts.map((contract) => (
            <MenuItem key={getField(contract, "contractId")} value={getField(contract, "contractId")}>
              {getField(contract, "contractNumber")} - {getField(contract, "contractName")}
            </MenuItem>
          ))}
        </TextField> */}
        <AppAutocomplete
          label="Hợp đồng chính"
          className="full"
          value={selectedContractId || ""}
          options={contracts.map((item) => {
            const id = getField(item, "contractId");
            const number = getField(item, "contractNumber") || "";
            const name = getField(item, "contractName") || "";
            return {
              value: id,
              label: `${number}${number && name ? " - " : ""}${name}`,
            };
          })}
          onChange={(value) => setSelectedContractId(value)}
        />
      </Box>

      <ContractStatisticsPanel
        contractId={selectedContractId}
        allowedSubcontractIds={allowedSubcontractIds}
        mainContract={contracts.find((contract) => String(getField(contract, "contractId")) === String(selectedContractId))}
      />
    </Box>
  );
}
